import {ValueListener} from "./interfaces";
import {observeDoesResponseWorkflowExist} from "./observeDoesResponseWorkflowExist";
import {observePageSettings} from "./observePageSettings";

export const observeIsAnythingLocked = (eventDataSource: any, listener: ValueListener<boolean>) => {

    listener = eventDataSource.wrapListener(listener);

    var securitySettings,
        pageSettings,
        responseWorkflowExists;

    // only looks at pages and channels now, no users security settings like passwordFree or RSVP locked
    // the RSVP should manage it's own Unlock dialog for now

    var compute = function () {
        // Event Location Requires Password
        // Event Date Requires Password
        // assumed true (public) if not present
        const infoSecuritySettings = securitySettings.info || {};
        const infoPlaceRead = infoSecuritySettings.place && infoSecuritySettings.place.read;
        const infoDateRead = infoSecuritySettings.date && infoSecuritySettings.date.read;
        if ((infoPlaceRead === false) || (infoDateRead === false)) {
            return true;
        }

        // Photos uploaded by guests Requires Password
        // Engagement Photos Requires Password
        // assumed true (public) if not present
        // if a moments node is locked, channelSettings.moments.read === undefined
        // if a moments node is public, channelSettings.moments.read === true
        // even if I have no moments, the moments node will be present
        const channelSecuritySettings = securitySettings.channels || {};
        const engagementMomentsRead = (channelSecuritySettings.engagementMoments && channelSecuritySettings.engagementMoments.read);
        const momentsRead = (channelSecuritySettings.moments && channelSecuritySettings.moments.read);
        if ((engagementMomentsRead === false) || (momentsRead === false)) {
            return true;
        }

        for (var page in pageSettings) {
            const settingsForPage = pageSettings[page];
            if (
                settingsForPage &&
                settingsForPage.isPresentable &&
                (settingsForPage.unlocked === false)
            ) {
                // there's something there ... but you aren't allowed to see it
                return true;
            }
        }

        return false;
    };

    var onUpdate = function () {
        var anyUndef = ([securitySettings,
            pageSettings,
            responseWorkflowExists].filter(x => (typeof x == "undefined")).length > 0);
        if (anyUndef) {
            return;
        }

        listener.onValue(compute());
    };

    eventDataSource.observeSecuritySettings({onValue: function (settings) {
        securitySettings = settings;
        onUpdate();
    }});

    observePageSettings(eventDataSource, {onValue: function (settings) {
        pageSettings = settings;
        onUpdate();
    }});

    observeDoesResponseWorkflowExist(eventDataSource, {onValue: function (b) {
        responseWorkflowExists = b;
        onUpdate();
    }});
};
